import {pick, omitBy, isNil} from 'lodash'
import {isSoundItem, isVideoItem} from 'powtoon-document'

const similarProps = [
  'actorId',
  'actorVariationId',
  'animationId',
  'assetType',
  'audioData',
  'audioType',
  'dataUrl',
  'emotion',
  'families',
  'family',
  'fileFormat',
  'folders',
  'hasBold',
  'hasItalic',
  'imageData',
  'isColorable',
  'isEditable',
  'isLipsyncSupported',
  'isPrototype',
  'isTintable',
  'itemType',
  'length',
  'licenseLevel',
  'localUrl',
  'loopEnd',
  'loopStart',
  'maintainAspectRatio',
  'modelData',
  'name',
  'pose',
  'previewUrl',
  'recommendedSpeakers',
  'scaling',
  'soundPackages',
  'source',
  'status',
  'tags',
  'thumbUrl',
  'variationOf',
  'videoData',
  'voiceoverId',
  'frameDefaultOffset'
]

export default function lib2ManifestItem(libraryItem){
  const isVideo = isVideoItem(libraryItem)
  if (isVideo && (!libraryItem.dataUrl && !libraryItem.localUrl)){
    throw new Error('no data url in video')
  }

  return {
    ...pick(libraryItem, similarProps),
    contentItemId: libraryItem.family || libraryItem.id,
    ...omitBy(
      isVideo && libraryItem.videoData ? {} : {originalWidth: libraryItem.width, originalHeight: libraryItem.height},
      isNil
    ),
    ...(isSoundItem(libraryItem) && isNil(libraryItem.length) ? {length: 0} : {})
  }
}
